export default function EditIcon(props) {
  const { width='9.142', height='9.142', fill='#000' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 9.142 9.142" fill={fill}>
      <path id="Icon_material-edit" data-name="Icon material-edit" d="M4.5,11.734v1.9H6.4l5.617-5.617-1.9-1.9Zm8.994-5.185a.506.506,0,0,0,0-.716L12.306,4.645a.506.506,0,0,0-.716,0l-.929.929,1.9,1.9Z" transform="translate(-4.5 -4.496)"/>
    </svg>
  );
}